'use client'
import { useEventListener } from "./useEventListener.hook"

export const useClickOutside = (ref, cb, elemId=null) => {
	useEventListener("click", e => {
		let skip = false
		if(elemId){
			const check = (id) => {
				const elem = document.getElementById(id);
				if(elem === e.target.closest(`#${id}`)){
					skip = true
				};
			}
			if(Array.isArray(elemId)){
				elemId.forEach(x => {
					check(x)
				})
			}else{
				check(elemId)
			}
		}
		if(skip) return
		if (ref.current == null || ref.current.contains(e.target)) return
		cb(e)
  }, (typeof window !== 'undefined') ?  window : null)
}